// removed by extract-text-webpack-plugin
module.exports = {"cls3":"client-components-Moon-styles__cls3___1RM9A","moonBack":"client-components-Moon-styles__moonBack___2BAt0"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Moon/styles.css
// module id = 396
// module chunks = 0